(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('EstadiosFenologicosService', EstadiosFenologicosServiceFactory);

  EstadiosFenologicosServiceFactory.$inject = [
    '$http'
  ];

  // eslint-disable-next-line max-lines-per-function
  function EstadiosFenologicosServiceFactory($http) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    const service = {
      loadProducts,
      save,
      update,
      create,
      getItem,
      deleteItem
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function loadProducts(filters) {
      const params = filters ? {
        descricao: filters.descricao || null,
        atividade: (filters.atividade || {}).id
      } : {};

      return $http.get(`${SERVER}v1/estadios`, { params: params }).then((response) => response.data);
    }

    function save(item) {
      if (item.id) {
        return update(item);
      }
      return create(item);
    }

    // TODO: complexity
    // eslint-disable-next-line complexity
    function update(estadio) {
      const estadioFenologico = {
        descricao: estadio.descricao,
        abreviatura: estadio.abreviatura,
        cd_atividade: (estadio.atividade || {}).id || null,
        ordem: estadio.ordem,
        tp_contagem: (estadio.tp_contagem || null)
      };

      return $http.patch(`${SERVER}v1/estadios/${estadio.id}`, { estadio: estadioFenologico });
    }

    // TODO: complexity
    // eslint-disable-next-line complexity
    function create(estadio) {
      const estadioFenologico = {
        descricao: estadio.descricao,
        abreviatura: estadio.abreviatura,
        cd_atividade: (estadio.atividade || {}).id || null,
        ordem: estadio.ordem,
        tp_contagem: (estadio.tp_contagem || null)
      };

      return $http.post(`${SERVER}v1/estadios`, { estadio: estadioFenologico });
    }

    function getItem(estadio, complete = true) {
      return $http.get(`${SERVER}v1/estadios/${estadio}?complete=${complete}`).then((response) => response.data);
    }

    function deleteItem(estadio) {
      return $http.delete(`${SERVER}v1/estadios/${estadio}`);
    }
  }
}());

